// This is the javascript entrypoint for the countdown section.
// This file and all its inclusions will be processed through esbuild

/*============================================================================
  CountdownTimer
==============================================================================*/

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.display = this.querySelector('[data-time-display]');
    this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
    this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
    this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
    this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
    this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
    this.hideTimerOnComplete = this.el.dataset.hideTimer;
    this.completeMessage = this.el.dataset.completeMessage;

    this.day = this.dataset.day;
    this.titleWeekend = this.dataset.title;
    this.hour = this.dataset.hour;

    this.timerComplete = false;

    this.isDateModal = this.dataset.isDateModal;

    this.init();
  }

  init() {
    setInterval(() => {
      if (!this.timerComplete) {
        this._calculate();
      }
    }, 1000);
  }

  _calculate() {
    let now = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });
    now = new Date(now);

    let targetDate = new Date(now);

    let currentDay = now.getDay();
    //formateamos a 7 parpa que sea domingo y haga los calculos bien
    if (currentDay == 0) {
      currentDay = 7;
    }

    const currentHour = now.getHours();
    const countdownTitle = this.querySelector('.countdown-title');

    if (currentDay === 5) {
      if (countdownTitle) {
        countdownTitle.textContent = this.titleWeekday;
      }

      targetDate.setDate(now.getDate() + (8 - currentDay));
      targetDate.setHours(this.hour, 0, 0, 0);

    } else if (currentDay == 4) {
      targetDate.setHours(this.hour, 0, 0, 0);
      if (currentHour >= this.hour) {
        if (countdownTitle) {
          countdownTitle.textContent = this.titleWeekend;
        }
        targetDate.setDate(now.getDate() + (8 - currentDay));
      } else {
        targetDate.setDate(targetDate.getDate());
      }

    } else if (currentDay >= 1 && currentDay <= 3) {
      targetDate.setHours(this.hour, 0, 0, 0);
      if (currentHour >= this.hour) {
        targetDate.setDate(targetDate.getDate() + 1);
      }

    } else {
      targetDate.setDate(now.getDate() + (8 - currentDay));
      targetDate.setHours(this.hour, 0, 0, 0);
      if (countdownTitle) {
        countdownTitle.textContent = this.titleWeekend;
      }
    }

    const timeDifference = targetDate.getTime() - now.getTime();
    if (timeDifference > 0) {
      const intervals = {
        hours: Math.floor((timeDifference / (1000 * 60 * 60))),
        minutes: Math.floor((timeDifference / (1000 * 60)) % 60),
        seconds: Math.floor((timeDifference / 1000) % 60),
        days: Math.floor(Math.floor((timeDifference / (1000 * 60 * 60))) / 24)
      };
      
      if (this.hoursPlaceholder) {
        this.hoursPlaceholder.innerHTML = intervals.hours;
      }

      if (this.minutesPlaceholder) {
        this.minutesPlaceholder.innerHTML = intervals.minutes;
      }

      if (this.secondsPlaceholder) {
        this.secondsPlaceholder.innerHTML = intervals.seconds;
      }


      if (this.hoursPlaceholder && this.minutesPlaceholder && this.secondsPlaceholder) {
        this._updateAttributes(intervals);
      }

      if (this.isDateModal) {
        const deliveryTitleContainer = document.querySelector('.text .title');
        const countdownTitleMobile = document.querySelector('.countdown-title.countdown-title-mobile');
        const countdownTitleDesktop = document.querySelector('.countdown-title.countdown-title-desktop');

        if (currentDay >= 5 || (currentDay == 4 && currentHour >= this.hour)) {
          const textDay = intervals.days > 1 ? `${intervals.days} days` : `day`;
          const textHour = intervals.hours > 1 ? `${intervals.hours} hours` : `hour`;
          const textMinute = intervals.minutes > 1 ? `${intervals.minutes} minutes` : `minute`;
          //para formatear el numero, y sea por ejemplo en vez de 1, poner 01
          if (intervals.minutes >= 0 && intervals.minutes < 10) {
            intervals.minutes = "0" + intervals.minutes;
          }
          if (intervals.hours >= 24) {
            //intervals.days = Math.floor(intervals.hours / 24);
            if (deliveryTitleContainer) {
              deliveryTitleContainer.innerHTML = `Get it this ${this.getFormattedDate(now, 2, true)}. Order in the next  ${textDay}`;
            }

            if (countdownTitleMobile) {
              countdownTitleMobile.innerHTML = `Order in the next ${textDay}.`;
            }

          }
          else if (intervals.hours > 1) {
            if (deliveryTitleContainer) {
              deliveryTitleContainer.innerHTML = `Get it this ${this.getFormattedDate(now, 2, true)}. Order in the next  ${textHour}`;
            }
            if (countdownTitleMobile) {
              countdownTitleMobile.innerHTML = `Order in the next ${textHour}.`;
            }

          }
          else {
            if (deliveryTitleContainer) {
              deliveryTitleContainer.innerHTML = `Get it this ${this.getFormattedDate(now, 2, true)}. Order in the next  ${textMinute}`;
            }
            if (countdownTitleMobile) {
              countdownTitleMobile.innerHTML = `Order in the next ${textMinute}.`;
            }
          }

          if (countdownTitleDesktop) {
            countdownTitleDesktop.innerHTML = this.titleWeekend;
          }
        }
        else {
          const hoursOrMinutes = intervals.hours > 0 ? intervals.hours == 1 ? `hour` : `${intervals.hours} hours` : intervals.minutes > 1 ? `${intervals.minutes} minutes` : `minute`;
          const formattedDate = this.getFormattedDate(now, 2, currentDay >= 5);
          if (deliveryTitleContainer) {
            deliveryTitleContainer.innerHTML = `Get it this ${formattedDate}. Order in the next ${hoursOrMinutes}`;
          }
          if (countdownTitleMobile) {
            countdownTitleMobile.innerHTML = `Order in the next ${hoursOrMinutes}.`;
          }
        }
      }

      setTimeout(() => {
        if (this.display) {
          this.display.classList.add('countdown__display--loaded');
        }
      }, 1);
    } else {
      if (this.completeMessage && this.messagePlaceholder) {
        this.messagePlaceholder.classList.add('countdown__timer-message--visible');
      }

      if (this.hideTimerOnComplete === 'true') {
        this.display.classList.remove('countdown__display--visible');
        this.display.classList.add('countdown__display--hidden');
      }

      if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
        this.block.classList.add('countdown__block--hidden');
      }

      this.timerComplete = true;
    }
  }

  _updateAttributes(intervals) {
    if (intervals.hours > 0) {
      this.hoursPlaceholder.parentElement.setAttribute('disable', '');
      this.minutesPlaceholder.parentElement.setAttribute('disable', '');
      this.secondsPlaceholder.parentElement.setAttribute('disable', '');
    } else if (intervals.hours === 0 && intervals.minutes > 0) {
      this.hoursPlaceholder.parentElement.setAttribute('disable', '');
      this.minutesPlaceholder.parentElement.removeAttribute('disable');
      this.secondsPlaceholder.parentElement.setAttribute('disable', '');
    } else if (intervals.hours === 0 && intervals.minutes === 0) {
      this.hoursPlaceholder.parentElement.setAttribute('disable', '');
      this.minutesPlaceholder.parentElement.setAttribute('disable', '');
      this.secondsPlaceholder.parentElement.removeAttribute('disable');
    }
  }

  getFormattedDate(currentDate, daysToAdd, nextWednesday = false) {
    const options = { weekday: 'long' };
    if (!nextWednesday) {
      const deliveryDate = new Date(currentDate);
      deliveryDate.setDate(currentDate.getDate() + daysToAdd);
      return deliveryDate.toLocaleDateString('en-US', options);
    } else {
      const daysUntilWednesday = (3 - currentDate.getDay() + 7) % 7;
      const nextWednesday = new Date(currentDate);
      nextWednesday.setDate(currentDate.getDate() + daysUntilWednesday);
      return nextWednesday.toLocaleDateString('en-US', options);
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);